export default __webpack_public_path__ + "static/media/u_warning-blue.5e6a1c6e.svg";